module.exports = __webpack_public_path__ + "img/banking.e3b1579c.png";